

/**
 *
 * @class LocomotiveDialogParams
 *
 * Helper to pass more complicated values when working with the new locomotive model dialog
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */

import {FAVRecord} from "@/models/project/f.a.v.record";

export class LocomotiveDialogParams {

  public name:  string    = '';
  public start: string    = '';
  public end:   string    = '';
  public fav:   FAVRecord = null;

  /** standard constructor */
  public constructor(init?: Partial<LocomotiveDialogParams>) {

    Object.assign(this, init);
  }
}
